import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Logo from '../SmartEvacLogo.jpg';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function AdminPage() {
  const navigate = useNavigate();
  const HandleHome = (event) => {
    event.preventDefault();
    navigate('/adminpage'); 
  };
  const SearchPerson = (event) => {
    event.preventDefault();
    navigate('/searchPerson'); 
  };
  const StartEvac = (event) => {
    event.preventDefault();
    navigate('/start'); 
  };

  const HandleAddPerson = (event) => {
    event.preventDefault();
    navigate('/addPersonOption');
  };
  const RemovePerson = (event) => {
    event.preventDefault();
    navigate('/removePersonOption'); 
  };
  const ModifyPerson = (event) => {
    event.preventDefault();
    navigate('/modify'); 
  };
  const emergencyPlan = (event) => {
    event.preventDefault();
    navigate('/emergencyPlan'); 
  };

  return (
    <Container className= "main-page-content">
      <Row>
        <Col>
          <img className="app-logo" src={Logo} width="400" height="50" alt="SmartEvac Logo" />
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col>
          <Navbar expand="lg" className="bg-body-tertiary">
            <Container>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                  <Nav.Link href="#home" onClick={HandleHome}>Home</Nav.Link>
                  <Nav.Link href="#link"onClick={SearchPerson} >Search</Nav.Link>
                  <Nav.Link href="#link" onClick={HandleAddPerson}>Add</Nav.Link>
                  <Nav.Link href="#link" onClick={RemovePerson}>Remove</Nav.Link>
                  <Nav.Link href="#link" onClick={ModifyPerson}>Modify</Nav.Link>
                  <Nav.Link href="#link" onClick={emergencyPlan}>Plan</Nav.Link>
                </Nav>
                <Nav className="ms-auto">
                  <Nav.Link href="#link" onClick={StartEvac}>Start Evacuation</Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </Col>
      </Row>
      <br></br>
      <Row className="justify-content-center">
        <Col xs={12} sm={8} md={6} lg={5}>
          <h2>Person modified successfully</h2>
        </Col>
      </Row>
    </Container>
  );
}

export default AdminPage;
